import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MCard from "components/Shared/MCard.tsx";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import MSelect from "components/Shared/MSelect.tsx";
import Box from "@mui/material/Box";

const changeStatusActions = [
  { label: "Re-open order for 1004p", value: "Re-open order for 1004p" },
  { label: "Update case as ready to assign to Appraiser", value: "Update case as ready to assign to Appraiser" },
  { label: "Re-open case that was Cancelled Pre-Inspection", value: "reopencancelledpreinspection" },
  { label: "Re-open case that was Closed Post Inspection", value: "reopenclosedpostinspection" },
];

class ChangeStatus extends AppInsightsTracker {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      controlNumber: "",
      action: "",
    };
  }

  submit() {
    const { controlNumber, action } = this.state;
    const { changeStatus } = this.props;
    changeStatus(Number(controlNumber), action);
  }

  handleControlNumberChange = (event) => {
    const value = event.target.value;
    // Only allow numeric input
    if (value === "" || /^\d+$/.test(value)) {
      this.setState({ controlNumber: value });
    }
  };

  render() {
    const { action } = this.state;
    return (
      <Box sx={{ padding: 1 }}>
        <MCard
          title="Change Case Status"
          sx={{ maxWidth: "700px", height: "auto" }}
          fields={[
            {
              key: "controlNumber",
              control: (
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Control #"
                  value={this.state.controlNumber}
                  onChange={this.handleControlNumberChange}
                />
              ),
            },
            {
              key: "action",
              control: (
                <MSelect
                  options={changeStatusActions}
                  enableAllOption={false}
                  onChange={(input) => {
                    this.setState({
                      action: input?.value || "",
                    });
                  }}
                  placeholder="Select Action"
                  getMenuPortalTarget={() => document.body}
                />
              ),
            },
            {
              key: "submit",
              control: (
                <Button className="full-width" disabled={!action} onClick={this.submit}>
                  Submit
                </Button>
              ),
            },
          ]}
        />
      </Box>
    );
  }
}

ChangeStatus.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  statusItems: PropTypes.object.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
};

export default ChangeStatus;
